module.exports = __webpack_public_path__ + "img/traffic-junction-7.b70de3cb.webp";